import React from 'react';

import { ICoordinates } from '../../interfaces/geo';

import { useDailyWeatherForecast } from '../../helpers/hooks/fishingWater/useDailyWeatherForecast';
import { DailyWeatherCard } from '../WeatherCards/DailyWeatherCard';
import { ContinuousCarousel } from '../Carousels/ContinuousCarousel/ContinuousCarousel';
import { useIsDesktopScreenWidthOrWider } from '../../helpers/hooks/useScreenWidth';
import { Heading } from '../Heading/Heading';
import { EMPTY_LIST_SIX } from '../../helpers/emptyListsForMapping';
import ContentLoader from 'react-content-loader';
import { twMerge } from 'tailwind-merge';

interface IProps {
  coordinates?: ICoordinates;
  title?: string;
}

const LoadingCards = ({ className }: { className?: string }) => (
  <>
    {EMPTY_LIST_SIX.map(({ id }) => (
      <div key={`weather-carousel-${id}`} className={twMerge(`size-full`, className)}>
        <ContentLoader
          uniqueKey={`loader-loader-${id}`}
          id={`loader-loader-${id}`}
          speed={2}
          backgroundColor="#f3f3f3"
          foregroundColor="#ecebeb"
          className="h-28 w-full"
        >
          <rect x="0" y="0" width="100%" height="100%" />
        </ContentLoader>
      </div>
    ))}
  </>
);

export const WeatherCarousel = ({ coordinates, title }: IProps) => {
  const isDesktopScreenWidthOrWider = useIsDesktopScreenWidthOrWider();
  const state = useDailyWeatherForecast(coordinates, 6, true);

  const isLoaded = state?.response === 'success';
  const hasFailed = state?.response === 'fail';
  const weatherData = state?.weatherData ?? [];

  if (hasFailed) {
    return null;
  }

  return isDesktopScreenWidthOrWider ? (
    <div className="flex flex-col gap-6 sm:gap-10">
      <Heading as="span" variant="sm">
        {title}
      </Heading>
      <div className="flex flex-row gap-4">
        {isLoaded ? (
          weatherData.map((dailyData, index) => {
            return <DailyWeatherCard className="grow" key={index} weatherData={dailyData} />;
          })
        ) : (
          <div className="flex size-full flex-row gap-4">
            <LoadingCards />
          </div>
        )}
      </div>
    </div>
  ) : (
    <ContinuousCarousel
      title={title}
      headingVariant="sm"
      headingAs="span"
      outerClass="!mt-0 md:hidden"
      dataTestId="weather-carousel"
      childrenClassName="w-col-2 min-w-col-2 mr-2 sm:w-col-3 sm:min-col-3"
      contentLoaderClassName="h-28 w-full w-col-2 min-w-col-2 sm:w-col-3 sm:min-col-3"
      contentLoaderKey="weather-carousel"
      showContentLoader
      isLoading={!isLoaded}
    >
      {weatherData.map((dailyData, index) => {
        return <DailyWeatherCard key={index} weatherData={dailyData} />;
      })}
    </ContinuousCarousel>
  );
};
